export default __webpack_public_path__ + "static/media/nextjs.8d64d648.png";